// extracted by mini-css-extract-plugin
export var quotation = "style-module--quotation--4b7a3";